import { render, staticRenderFns } from "./bulkCargoIndex.vue?vue&type=template&id=6475ce85&"
import script from "./bulkCargoIndex.vue?vue&type=script&lang=js&"
export * from "./bulkCargoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports